module.exports = __webpack_public_path__ + "img/home-icon-8.6b597715.png";